
import { usePublicHeroData } from '@/hooks/usePublicHeroData';
import { useHeroSettings } from '@/hooks/useHeroSettings';

// Re-export types for backward compatibility
export type { MappedHeroContent, MappedHeroFeaturedProduct } from '@/hooks/usePublicHeroData';
export type { HeroSettings } from '@/hooks/useHeroSettings';

/**
 * Combined hook for hero data - now uses separate public and settings hooks
 * This prevents RLS policy errors by separating public from potentially protected data
 */
export const useHeroData = () => {
    const { data: publicData, isLoading: publicLoading, error: publicError } = usePublicHeroData();
    const { data: settings, isLoading: settingsLoading, error: settingsError } = useHeroSettings();

    // Combine the data
    const data = publicData && settings ? {
        heroContent: publicData.heroContent,
        featuredProducts: publicData.featuredProducts,
        settings: settings
    } : undefined;

    const isLoading = publicLoading || settingsLoading;
    const error = publicError || settingsError;

    return {
        data,
        isLoading,
        error,
        isError: !!error
    };
};
